import template from './branch_funding_source_holiday.create.html';
import controller from './branch_funding_source_holiday.create.controller';
import './branch_funding_source_holiday.create.scss'

let branchFundingSourceHolidayCreateComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template,
    controller
}

export default branchFundingSourceHolidayCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/create/branch_funding_source_holiday.create.component.js